import { render, staticRenderFns } from "./SpecimenRecord.vue?vue&type=template&id=a15788ea&scoped=true"
import script from "./SpecimenRecord.vue?vue&type=script&lang=js"
export * from "./SpecimenRecord.vue?vue&type=script&lang=js"
import style0 from "./SpecimenRecord.vue?vue&type=style&index=0&id=a15788ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15788ea",
  null
  
)

export default component.exports